import { useEffect, useState } from 'react'
import { isNativeApp } from '../../client'
import TaboolaDiv from './TaboolaDiv'
import {
  PocTaboolaList,
  PocTaboolaPageType,
  PocTaboolaSuffixId,
} from './TaboolaTypes'
import { getTaboolaProps } from './functions'
import { usePage } from '../../contexts'
import { ITaboolaOptions } from './types'
import { useRouter } from 'next/router'
import { useTaboola } from './useTaboola'

type Props = {
  pageType: PocTaboolaPageType | typeof PocTaboolaList | string
  suffixId: PocTaboolaSuffixId
  index?: number
  os: 'Web' | 'Android' | 'iOS' | string | boolean
  pub: string
}

// TODO: remove default value of index
interface ITaboolaSate {
  id: string
  options: ITaboolaOptions
}

export const TaboolaForDiv = ({
  pageType,
  suffixId,
  index,
  os,
  pub,
}: Props) => {
  const page = usePage()
  const { addWidget } = useTaboola()
  const { asPath } = useRouter()
  const [taboolaSate, setTaboolaState] = useState<ITaboolaSate | null>(null)

  useEffect(() => {
    const _isNativeApp = isNativeApp()
    const { id, options } = getTaboolaProps({
      pageType,
      _isNativeApp,
      index,
      suffixId,
      os,
      isFaceLift: page?.PageMeta?.isFaceLift,
    })
    setTaboolaState({ id, options })
    addWidget(id)
  }, [addWidget, index, os, page?.PageMeta?.isFaceLift, pageType, suffixId])

  if (taboolaSate === null) {
    return null
  }
  return (
    <TaboolaDiv
      key={asPath + taboolaSate.id}
      id={taboolaSate.id}
      options={taboolaSate.options}
      pub={pub}
      suffixId={suffixId}
    />
  )
}
